import React from "react";
import { Link } from "react-router-dom";
import { FaXTwitter, FaWhatsapp } from "react-icons/fa6";
import logo from "../../assets/logo.png";
import { footerColumns, mapEmbedUrl } from "../../data/footerLinks";

const socials = [
  { label: "X", Icon: FaXTwitter, href: "https://x.com/cargopowerltd" },
  { label: "WhatsApp", Icon: FaWhatsapp, href: "https://wa.me/254719218783" },
];

const Footer = () => (
  <footer className="bg-inverse-surface text-inverse-on-surface">
    <div className="mx-auto grid max-w-container-max grid-cols-1 gap-stack-lg px-margin-mobile py-16 md:grid-cols-2 md:px-gutter lg:grid-cols-6">
      {/* Brand */}
      <div className="lg:col-span-2">
        <Link to="/" className="inline-block">
          <img
            src={logo}
            alt="Cargo Power Logistics"
            className="h-24 w-auto object-contain"
          />
        </Link>
        <p className="mt-6 max-w-xs font-body-md text-body-md text-primary-fixed-dim">
          Forward momentum, absolute reliability, and high-tech precision in
          global shipping.
        </p>
        <div className="mt-6 flex gap-4">
          {socials.map(({ label, Icon, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-primary-fixed-dim/40 text-lg text-primary-fixed transition-colors hover:border-primary-container hover:bg-primary-container hover:text-white"
            >
              <Icon />
            </a>
          ))}
        </div>
      </div>

      {/* Link columns */}
      {footerColumns.map((col) => (
        <div key={col.heading}>
          <h4 className="mb-4 font-label-sm text-label-sm font-bold uppercase text-primary-fixed">
            {col.heading}
          </h4>
          <ul className="space-y-2">
            {col.links.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className="font-body-md text-body-md text-primary-fixed-dim opacity-80 transition-colors hover:text-primary-container hover:opacity-100"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}

      {/* Location map */}
      <div>
        <h4 className="mb-4 font-label-sm text-label-sm font-bold uppercase text-primary-fixed">
          Locations
        </h4>
        <div className="h-28 overflow-hidden rounded-lg border border-outline-variant/20">
          <iframe
            src={mapEmbedUrl}
            title="Cargo Power location — Nairobi"
            className="h-full w-full"
            loading="lazy"
          />
        </div>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-container-max flex-col items-center justify-center gap-3 px-margin-mobile py-6 text-center font-body-md text-body-md text-primary-fixed-dim sm:flex-row md:px-gutter">
        <p>
          © {new Date().getFullYear()} Cargo Power Logistics. All rights
          reserved.
        </p>
        <span className="hidden text-white/20 sm:inline">·</span>
        <a
          href="https://www.tyneitconsulting.africa/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2"
          aria-label="Built by Tyne Africa IT Consulting"
        >
          <span className="text-body-sm text-primary-fixed-dim/80">
            Built by
          </span>
          <img
            src={`${process.env.PUBLIC_URL}/200-100px.png`}
            alt="Tyne Africa IT Consulting"
            loading="lazy"
            className="h-8 w-auto rounded-md bg-white px-2 py-1"
          />
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
